import api from "../../api";

class Holidays {
  index() {
    return api.get('calendario/feriados');
   }
  store(data) {
    return api.post("calendario/feriados", data);
  }
  show(id) {
    return api.get(`calendario/feriados/${id}`);
  }
  update(id, data) {
    return api.put(`calendario/feriados/${id}`, data);
  }
  destroy(id) {
    return api.delete(`calendario/feriados/${id}`);
  }
}

export default new Holidays();
